import axios from 'axios';
import React, { useContext, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { Context } from '../context/Context';
import { commonText as text } from '../Database/Database';
import { reactLocalStorage } from 'reactjs-localstorage'
import { getHeaders, base } from "../Config";

export default function SideMenu() {
    const history = useHistory();
    const { handleSideMenu, handleLangModal, lang, handleVerifyUser, handleModal, showSideBar } = useContext(Context);

    const onHandleLang = () => {
        console.log("Lang Select");
        handleLangModal(true);
        handleSideMenu(false);
    }
    const uid = reactLocalStorage.get("uid")



    const onHandleUnsub = () => {
        // unsub logic goes here

        axios({
            method: 'post',
            url: base + "unsubscribe",
            data: { "uid": uid },
            headers: { ...getHeaders(), Language: `${lang}` }
        }
        ).then((resp) => {
            console.log("unsub response ----> ", resp.data)
            if (resp.data.status !== '' && resp.data.status != undefined) {
                if (resp.data.status === 'failed') {
                    // window.open(rediret_url,"_self")

                } else if (resp.data.status === 'success') {

                }
            }
            reactLocalStorage.set("subStatus", resp.data.subStatus)
            // set loader false
        }).then((error) => {
            console.log("error -----> ", error)
        })
    }

    const onClickHandle = () => {
        const modalData = {
            title: text.modal.oops[lang],
            body: text.modal.doYouReallyUnsub[lang],
            btn: [text.modal.yes[lang], text.modal.no[lang]],
        }
        handleModal(modalData, true)
    }




    return (

            <div className={`absolute bg-white z-40 h-full w-[15rem]`}>
                <div className='text-right font-bold text-4xl absolute z-50 right-4' onClick={() => handleSideMenu(false)}>&times;</div>
                <div className='text-black pt-10'>
                    <div className='my-10 text-left pl-6'>
                        <div className='py-4 font-bold pl-0  border-b mx-1' onClick={onHandleLang}>{text.language[lang]}</div>
                        <div className='py-4 font-bold  border-b mx-1' onClick={onClickHandle}>{text.unsubscribe[lang]}</div>
                    </div>
                </div>
            </div>
    )
}
